import { InvertedCorner } from "../NordenNavbar";


export const XIconSvg = () =>{
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,62.57,48h29L193.43,208Z"></path></svg>
   )
}
export const PinterestIcon = () =>{
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M224,112c0,22.57-7.9,43.2-22.23,58.11C188.39,184,170.25,192,152,192c-17.88,0-29.82-5.86-37.43-12l-10.78,45.82A8,8,0,0,1,96,232a8.24,8.24,0,0,1-1.84-.21,8,8,0,0,1-6-9.62l32-136a8,8,0,0,1,15.58,3.66l-16.9,71.8C122,166,131.3,176,152,176c27.53,0,56-23.94,56-64A72,72,0,1,0,73.63,148a8,8,0,0,1-13.85,8A88,88,0,1,1,224,112Z"></path></svg>
   )
}
export const LinkedinIcon = () =>{
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z"></path></svg>
   )
}
export const GithubIcon = () =>{
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000000" viewBox="0 0 256 256"><path d="M208.31,75.68A59.78,59.78,0,0,0,202.93,28,8,8,0,0,0,196,24a59.75,59.75,0,0,0-48,24H124A59.75,59.75,0,0,0,76,24a8,8,0,0,0-6.93,4,59.78,59.78,0,0,0-5.38,47.68A58.14,58.14,0,0,0,56,104v8a56.06,56.06,0,0,0,48.44,55.47A39.8,39.8,0,0,0,96,192v8H72a24,24,0,0,1-24-24A40,40,0,0,0,8,136a8,8,0,0,0,0,16,24,24,0,0,1,24,24,40,40,0,0,0,40,40H96v16a8,8,0,0,0,16,0V192a24,24,0,0,1,48,0v40a8,8,0,0,0,16,0V192a39.8,39.8,0,0,0-8.44-24.53A56.06,56.06,0,0,0,216,112v-8A58.14,58.14,0,0,0,208.31,75.68ZM200,112a40,40,0,0,1-40,40H112a40,40,0,0,1-40-40v-8a41.74,41.74,0,0,1,6.9-22.48A8,8,0,0,0,80,73.83a43.81,43.81,0,0,1,.79-33.58,43.88,43.88,0,0,1,32.32,20.06A8,8,0,0,0,119.82,64h32.35a8,8,0,0,0,6.74-3.69,43.87,43.87,0,0,1,32.32-20.06A43.81,43.81,0,0,1,192,73.83a8.09,8.09,0,0,0,1,7.65A41.72,41.72,0,0,1,200,104Z"></path></svg>
   )
}



const SocialMediaArray =[
   {name: 'X', link:'https://x.com/ArvazMansuri', icon: <XIconSvg />},
   {name: 'Pinterest', link: 'https://in.pinterest.com/arvazanakuzhy/', icon: <PinterestIcon /> },
   {name: 'Linkedin', link:'https://www.linkedin.com/in/arvaz-mansuri-7a9835272/', icon: <LinkedinIcon /> },
   {name: 'Github.com', link:'https://github.com/arvtia',icon: <GithubIcon />}
]



const NordenSocialMedia = () => {
   return (
      <div className="relative  max-w-xl mx-auto w-full mt-3 py-3 rounded-md bg-[#F9F9F9] bg-stripes-light">
         <div className="absolute top-0 left-0">
            <div className="relative bg-white shadow-sm px-4 py-2 rounded-br-2xl">
               <p className="text-lg">Find me</p>
               <InvertedCorner className="absolute left-0 rotate-180 top-11 text-white"/>
               <InvertedCorner className="absolute -right-6  rotate-180 -top-0 text-white"/>
            </div>
         </div>


         <div className="p-3 mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            {SocialMediaArray.map((i, idx) => (
               <a 
                  key={idx} 
                  href={i.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group p-4 rounded-xl bg-white border border-neutral-100 flex items-center justify-between transition-all duration-300 hover:shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1"
               >
                  <div className="flex flex-col">
                  <span className="text-sm font-bold text-neutral-800 underline-offset-4 group-hover:underline">
                     {i.name}
                  </span>
                  <span className="text-[10px] uppercase tracking-widest text-neutral-400 font-medium">
                     Follow
                  </span>
                  </div>

                  <div className="p-2 rounded-lg bg-neutral-50 text-neutral-500   transition-colors duration-300">
                  {i.icon}
                  </div>
               </a>
            ))}
            </div>
      </div>
   )
}

export default NordenSocialMedia;
